import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { Http } from "./namespaces/Http";
import "@/plugins/index";
import i18n from "./i18n";
import IntegerOnly from './directives/IntegerOnly';

Vue.config.productionTip = false;

new Http.ApiJwtService();

Vue.directive('integer-only', IntegerOnly);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
